export const templateTypes = ["Basic", "Pro", "Custom"];
